import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import getProductById from "../helpers/getProductById";
import "./IndividualProductPage.scss";
import ThemePicker from "./ThemePicker";
import CustomizerContainer from "./CustomizerContainer";
import Button from "./LabelCustomizer/Button";
import { CloseCircleOutlined } from "@ant-design/icons";
// import SingleTemplateSelector from "./SingleTemplateSelector";

const IndividualProductPage = () => {
  const { id } = useParams();
  const [{ products }, dispatch] = useStateValue();
  const [isThemePicking, setThemePicking] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [showProductInformation, setShowProductInformation] = useState(true);
  const [isCustomizing, setCustomizing] = useState(false);
  const [useTemplate, setUseTemplate] = useState(null);

  const product = getProductById(id, products);

  const showThemePicker = (id) => {
    setThemePicking(true);
    setCurrentProduct(id);
    setShowProductInformation(false);
  };
  const cancel = () => {
    setThemePicking(false);
    setShowProductInformation(true);
  };

  const showCustomizer = (id) => {
    setCustomizing(true);
    setThemePicking(false);
  };

  const goBack = () => {
    setCustomizing(false);
    setThemePicking(true);
  };

  const ProductInformation = () => {
    return (
      <main>
        <div className="product-container">
          <img className="product-image" src={product.image} alt="wine" />
          <div className="product-info">
            <h1 className="page-title">{product.name}</h1>
            <p className="product-description">{product.description}</p>
            <p className="product-price">${product.price}</p>
            <button
              className="button is-outlined is-rounded"
              onClick={() => showThemePicker(product.id)}
            >
              Customize
            </button>
          </div>
        </div>
      </main>
    );
  };
  return (
    <body>
      {showProductInformation && <ProductInformation />}

      {isThemePicking && (
        <main>
          {/* <ThemePicker
            productID={currentProduct}
            cancel={cancel}
            showCustomizer={showCustomizer}
            setUseTemplate={setUseTemplate}
          /> */}
          {/* <SingleTemplateSelector
            productID={currentProduct}
            cancel={cancel}
            showCustomizer={showCustomizer}
            setUseTemplate={setUseTemplate}
          /> */}
          <button
            className="button is-outlined is-danger is-rounded cancel-button"
            onClick={cancel}
            Icon={CloseCircleOutlined}
          >
            <span className="icon">
              <CloseCircleOutlined />
            </span>
            <span>Cancel</span>
          </button>
          
        </main>
      )}
      {isCustomizing && (
        <CustomizerContainer
          productID={currentProduct}
          goBack={goBack}
          useTemplate={useTemplate}
          setUseTemplate={setUseTemplate}
        />
      )}
    </body>
  );
};

export default IndividualProductPage;
